var _path, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlay(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 77,
    height: 77,
    viewBox: "0 0 77 77",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.6992 67.0478C44.5493 72.2184 61.6108 63.4966 66.8073 47.5671C72.0038 31.6377 63.3674 14.5328 47.5174 9.36217C31.6673 4.19159 14.6058 12.9134 9.40928 28.8428C4.21279 44.7722 12.8492 61.8772 28.6992 67.0478Z",
    fill: "#4286F5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_957_50722)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.7507 44.4628L33.6432 26.3996L35.9011 27.1362L30.0086 45.1994L27.7507 44.4628ZM31.9957 52.5094L41.8166 22.4042L44.0745 23.1407L34.2536 53.246L31.9957 52.5094ZM23.5056 36.4162L25.4698 30.3951L27.7277 31.1317L25.7635 37.1528L23.5056 36.4162ZM40.1691 48.5139L46.0616 30.4508L48.3195 31.1873L42.427 49.2505L40.1691 48.5139ZM48.3425 44.5184L50.3067 38.4974L52.5646 39.234L50.6004 45.255L48.3425 44.5184Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_957_50722"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 38,
    fill: "white",
    transform: "translate(25.8645 13.8691) rotate(18.0673)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay);
export default __webpack_public_path__ + "static/media/play.5da6c52ec04a61fa82310b5922910c79.svg";
export { ForwardRef as ReactComponent };